import { httpCreate } from './http';

const http = httpCreate('/srv/invite-award-activity');

export const inviteAwardActivity = {
	// 活动列表
	getList(userId, params) {
		return http.get(`/list`, { params });
	},
	//保存邀请奖励
	add(data, params) {
		return http.post('', data, { params });
	},
	// 根据id获取活动信息
	getDetailById(id) {
		return http.get(`${id}`);
	},
	// 活动开关
	switch(id, status) {
		return http.post(`/${id}/switch/${status}`);
	},
	// 删除活动
	delete(id) {
		return http.delete(`/${id}`);
	},
	// 修改活动
	update(id, data) {
		return http.put(`/${id}`, data);
	},
	// 活动参与列表
	joinList(id, params) {
		return http.get(`/winList/${id}`, { params });
	},
	// 邀请人列表
	inviteList(rainActivityId, userId, params) {
		return http.get(`/${rainActivityId}/inviteList/${userId}`, { params });
	},
};
